import { Box, FormControl, InputLabel, Select, Typography } from '@mui/material'
import { ArrowDropDownIcon, DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import React, { useEffect } from 'react'
import downlod from '../../assets/aldi/images/DownloadImage.png'
import { ApiGetTrendData } from '../../apiService/Core/Apicall';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../global/config/store';
import { setSelectedMonth } from '../../global/config/Reducer/MonthSlice';
import storage from '../../utils/storage';

function TrendData() {
    const selectedMonth = useSelector((state: RootState) => state.month.selectedMonth)
    const dispatch = useDispatch()
    const [startMonth, setStartMonth] = React.useState<any>(dayjs(selectedMonth).startOf('year'));
    const [endMonth, setEndMonth] = React.useState<any>(dayjs(selectedMonth).startOf('month'));

    const downloadtrenddata = async (reportType: string, reportName:string) => {
        const data = `?clientEntityId=${storage.getItem('clientEntityId')}&s_month=${startMonth.month() + 1}&s_year=${startMonth.year()}&e_month=${endMonth.month() + 1}&e_year=${endMonth.year()}&reportType=${reportType}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`
        try {
            const res = await ApiGetTrendData(data);

            const blob = new Blob([res], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${reportName}_${startMonth.format('MMM')}-${startMonth.format('YY')}_to_${endMonth.format('MMM')}-${endMonth.format('YY')}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            alert(error)
        }
    }
    useEffect(() => {
        setEndMonth(dayjs(selectedMonth))
    }, [selectedMonth])
    return (
        <Box>
            <Box className='d-flex flex-wrap-reverse align-items-center justify-content-between mb-2'>
                <Typography className='fw-bold' whiteSpace='nowrap' fontSize={{ xs: '18px', md: '20px' }}>Trend Data</Typography>
                <Box className='d-flex align-items-center justify-content-end col-9'>

                    {/* <Box justifyContent={{ xs: 'start', md: 'end' }} border='1px solid red' className='col-5  d-flex align-itmes-center'> */}
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Box display="flex" justifyContent={'end'} width='27%' gap={3}>
                            <DatePicker value={startMonth} className='col-5'
                                label="Start Month: "
                                views={['month', 'year']}
                                format="MMM-YY"
                                maxDate={endMonth}
                                onChange={(e) => { setStartMonth(e); }}
                                slots={{
                                    openPickerIcon: ArrowDropDownIcon,
                                }}
                            />
                            <DatePicker value={endMonth} className='col-5'
                                label="End Month:"
                                views={['month', 'year']}
                                format="MMM-YY"
                                minDate={startMonth}
                                onChange={(e: any) => {
                                    const isoString = e?.startOf('month').toISOString();
                                    dispatch(setSelectedMonth(isoString));
                                }}
                                slots={{
                                    openPickerIcon: ArrowDropDownIcon,
                                }}
                            />
                        </Box>
                    </LocalizationProvider>
                    {/* </Box> */}
                </Box>

            </Box>

            <Box className='d-flex align-items-center  w-100 h-100 gap-3'>
                <Box className='flex-grow-1 border h-100 border-20 p-3 px-4'>
                    <Typography className='text-main mb-3'>Compliance</Typography>
                    <Box className='bg-main p-2 px-3 mb-3 border-20' >
                        <Box className='d-flex align-items-start justify-content-between' >
                            <Typography variant='h1' sx={{ color: '#FFFFFF3A' }} fontWeight='400'>01</Typography>
                            <Box className='border border-20 d-flex align-items-center justify-content-center' height='50px' width='50px' onClick={() => { downloadtrenddata('national_trend_by_questions_complince', 'National-Trend-by-Question-compliance') }}><Box className='h-75' component='img' src={downlod}></Box></Box>
                        </Box>
                        <Typography variant='h6' className='fw-bold' sx={{ color: '#FFFFFF' }} fontWeight='400'>National Trend By Question</Typography>
                    </Box>
                    <Box className='bg-main p-2 mb-3 px-3  border-20'>
                        <Box className='d-flex align-items-start justify-content-between' >
                            <Typography variant='h1' sx={{ color: '#FFFFFF3A' }} fontWeight='400'>02</Typography>
                            <Box className='border border-20 d-flex align-items-center justify-content-center' height='50px' width='50px' onClick={() => { downloadtrenddata('rank_by_region_categories_complince','Rank-by-Region-and-Director-with-Question-Categories-compliance') }}><Box className='h-75' component='img' src={downlod}></Box></Box>
                        </Box>
                        <Typography variant='h6' className='fw-bold' sx={{ color: '#FFFFFF' }} fontWeight='400'>Rank By Question Categories</Typography>
                    </Box>
                    <Box className='bg-main p-2 mb-3 px-3 border-20'>
                        <Box className='d-flex align-items-start justify-content-between' >
                            <Typography variant='h1' sx={{ color: '#FFFFFF3A' }} fontWeight='400'>03</Typography>
                            <Box className='border border-20 d-flex align-items-center justify-content-center' height='50px' width='50px' onClick={() => { downloadtrenddata('rank_by_busienss_complince','Rank-By-Business-Units-compliance') }}><Box className='h-75' component='img' src={downlod}></Box></Box>
                        </Box>
                        <Typography variant='h6' className='fw-bold' sx={{ color: '#FFFFFF' }} fontWeight='400'>Ranking</Typography>
                    </Box>
                    <Box className='bg-main p-2 px-3 border-20'>
                        <Box className='d-flex align-items-start justify-content-between' >
                            <Typography variant='h1' sx={{ color: '#FFFFFF3A' }} fontWeight='400'>04</Typography>
                            <Box className='border border-20 d-flex align-items-center justify-content-center' height='50px' width='50px' onClick={() => { downloadtrenddata('rank_by_region_question_complince','Rank-by-Region-and-Director-with-Question-Wise-compliance') }}><Box  className='h-75' component='img' src={downlod}></Box></Box>
                        </Box>
                        <Typography variant='h6' className='fw-bold' sx={{ color: '#FFFFFF' }} fontWeight='400'>Ranking By Question Wise</Typography>
                    </Box>
                </Box>
                <Box className='flex-grow-1 border h-100 border-20 p-3 px-4'>
                    <Typography className='text-main mb-3'>Moments That Matter</Typography>
                    <Box className='bg-secondary p-2 px-3 mb-3 border-20'>
                        <Box className='d-flex align-items-start justify-content-between' >
                            <Typography variant='h1' sx={{ color: '#FFFFFF3A' }} fontWeight='400'>01</Typography>
                            <Box className='border border-20 d-flex align-items-center justify-content-center' height='50px' width='50px' onClick={() => { downloadtrenddata('national_trend_by_questions_mysteryShop','National-Trend-by-Question-MomentsThatMatter') }}><Box className='h-75' component='img' src={downlod}></Box></Box>
                        </Box>
                        <Typography variant='h6' className='fw-bold' sx={{ color: '#FFFFFF' }} fontWeight='400'>National Trend By Question</Typography>
                    </Box>
                    <Box className='bg-secondary p-2 px-3 mb-3 border-20'>
                        <Box className='d-flex align-items-start justify-content-between'>
                            <Typography variant='h1' sx={{ color: '#FFFFFF3A' }} fontWeight='400'>02</Typography>
                            <Box className='border border-20 d-flex align-items-center justify-content-center' height='50px' width='50px' onClick={() => { downloadtrenddata('rank_by_region_categories_mystreyshop','Rank-by-Region-and-Director-with-Question-Categories-MomentsThatMatter')}}><Box className='h-75' component='img' src={downlod}></Box></Box>
                        </Box>
                        <Typography variant='h6' className='fw-bold' sx={{ color: '#FFFFFF' }} fontWeight='400'>Rank By Question Categories</Typography>
                    </Box>
                    <Box className='bg-secondary p-2 px-3  mb-3 border-20'>
                        <Box className='d-flex align-items-start justify-content-between' >
                            <Typography variant='h1' sx={{ color: '#FFFFFF3A' }} fontWeight='400'>03</Typography>
                            <Box className='border border-20 d-flex align-items-center justify-content-center' height='50px' width='50px' onClick={() => { downloadtrenddata('rank_by_busienss_mysteryShop','Rank-By-Business-Units-MomentsThatMatter') }}><Box className='h-75' component='img' src={downlod}></Box></Box>
                        </Box>
                        <Typography variant='h6' className='fw-bold' sx={{ color: '#FFFFFF' }} fontWeight='400'>Ranking</Typography>
                    </Box>
                    <Box className='bg-secondary p-2 px-3 border-20'>
                        <Box className='d-flex align-items-start justify-content-between' >
                            <Typography variant='h1' sx={{ color: '#FFFFFF3A' }} fontWeight='400'>04</Typography>
                            <Box className='border border-20 d-flex align-items-center justify-content-center' height='50px' width='50px' onClick={() => { downloadtrenddata('rank_by_region_question_mystreyshop','Rank-by-Region-and-Director-with-Question-Wise-MomentsThatMatter') }}><Box className='h-75' component='img' src={downlod}></Box></Box>
                        </Box>
                        <Typography variant='h6' className='fw-bold' sx={{ color: '#FFFFFF' }} fontWeight='400'>Ranking By Question Wise</Typography>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default TrendData
